<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { TabsTrigger, type TabsTriggerProps, useForwardProps } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<TabsTriggerProps & { class?: string | string[]; activeValue: string }>()

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
const tab = ref<any>(null)

watch(
    () => props.activeValue,
    (newVal) => {
        if (newVal === forwardedProps.value.value) {
            tab.value?.$el.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            })
        }
    },
)
</script>

<template>
    <TabsTrigger
        ref="tab"
        v-bind="forwardedProps"
        :class="
            cn(
                'px-4 py-3',
                'inline-flex z-10 items-center justify-center whitespace-nowrap',
                'text-base text-plus-lp-dark-blue-400 font-medium',
                'data-[state=active]:text-plus-lp-green-one',
                'transition-all duration-400 lp-ease-in-out',
                'ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-plus-lp-focus',
                'disabled:pointer-events-none disabled:opacity-50',
                'hover:data-[state=active]:bg-plus-lp-dark-blue-500 h-full',
                props.class,
            )
        "
    >
        <span class="truncate">
            <slot />
        </span>
    </TabsTrigger>
</template>
